require('./accountBalanceToday.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { FormattedText, getLanguage } = require('core/i18n').i18n;

// @helpers
const { toFirstUppercase } = require('utilities/stringHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @components
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const language = getLanguage();
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @ constants
const { CREDIT } = require('constants/flagBasedFeatures');


class AccountBalanceToday extends React.Component {
    getRowBalance() {
        const { immAccount, immInvestmentCredit } = this.props;
        const existsCredit = !!immInvestmentCredit;
        const amount = existsCredit ? immInvestmentCredit.get('limit') : immAccount.getIn(['balances', 'pregrantedCredit']);
        const text = existsCredit ? (
            toFirstUppercase(immAccount.getIn(['catalogData', 'product']))
        ) : <FormattedText value="accountBalanceToday-availableCcr" />;
        const plainAmountObject = getPlainAmountObject(amount);

        return (
            <OKTableRow>
                <OKTableCell>
                    {text}
                </OKTableCell>
                <OKTableCell className="account-balance-today__cell-balance">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                    />
                </OKTableCell>
            </OKTableRow>
        );
    }
    render() {
        const { immAccount } = this.props;
        const rowBalance = this.getRowBalance();
        const plainAmountBalanceObject = getPlainAmountObject(immAccount.get('balance'));
        const plainAmountRetentionObject = getPlainAmountObject(immAccount.getIn(['balances', 'totalPendings']));
        const plainAmountTotalObject = getPlainAmountObject(immAccount.getIn(['balances','availableBalance']));

        return (
            <article className="account-balance-today">
                <section>
                    <h3 className="account-balance-today__title">
                        <FormattedText value="accountBalanceToday-title" />
                    </h3>
                    <OKTable
                        id="account-balance-today-table"
                        className="account-balance-today__table"
                    >
                        <tbody>
                            <OKTableRow>
                                <OKTableCell>
                                    <FormattedText value="accountBalanceToday-balance" />
                                </OKTableCell>
                                <OKTableCell className="account-balance-today__cell-balance">
                                    <OneLineSymbolAmount
                                        amountObject={plainAmountBalanceObject}
                                        language={language}
                                        amountObjectFormatted={formatAmountObject(plainAmountBalanceObject, true)}/>
                                </OKTableCell>
                            </OKTableRow>
                            <FeatureTogglingRender notAllowedProductKey={CREDIT} >
                                {rowBalance}
                            </FeatureTogglingRender>
                            <OKTableRow>
                                <OKTableCell>
                                    <FormattedText value="accountBalanceToday-retentions" />
                                </OKTableCell>
                                <OKTableCell className="account-balance-today__cell-balance">
                                    <OneLineSymbolAmount
                                        amountObject={plainAmountRetentionObject}
                                        language={language}
                                        amountObjectFormatted={formatAmountObject(plainAmountRetentionObject, true)} />
                                </OKTableCell>
                            </OKTableRow>
                            <tr className="account-balance-today__total-row">
                                <OKTableCell className="account-balance-today__total-balance">
                                    <FormattedText value="accountBalanceToday-availableBalance" />
                                </OKTableCell>
                                <OKTableCell className="account-balance-today__cell-balance">
                                    <OneLineSymbolAmount
                                        amountObject={plainAmountTotalObject}
                                        language={language}
                                        amountObjectFormatted={formatAmountObject(plainAmountTotalObject, true)}
                                    />
                                </OKTableCell>
                            </tr>
                        </tbody>
                    </OKTable>
                </section>
            </article>
        );
    }
}

AccountBalanceToday.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immInvestmentCredit: PropTypes.object
};

module.exports = AccountBalanceToday;
